import { MOLDURA } from '../config/theme';

/** Octógono: retângulo com os quatro cantos chanfrados em `c`. */
function tracar (g, x, y, w, h, c, lados) {
    const e = lados.esq ? c : 0;
    const d = lados.dir ? c : 0;
    g.beginPath();
    g.moveTo(x + e, y);
    g.lineTo(x + w - d, y);
    g.lineTo(x + w, y + d);
    g.lineTo(x + w, y + h - d);
    g.lineTo(x + w - d, y + h);
    g.lineTo(x + e, y + h);
    g.lineTo(x, y + h - e);
    g.lineTo(x, y + e);
    g.closePath();
}

/**
 * Moldura de três fios (fora / meio / dentro) com cantos chanfrados, como
 * nos campos e botões do Figma. Desenhada em Graphics para aceitar qualquer
 * largura sem distorcer os cantos.
 */
export const MolduraPixel = {
    /**
     * @param {Phaser.GameObjects.Graphics} g
     * @param {number} x canto superior esquerdo
     * @param {number} y
     * @param {number} w
     * @param {number} h
     * @param {{fundo:number|null, fio:number, fioMeio:number}} cores `fundo: null` desenha só os fios
     * @param {{esq:boolean, dir:boolean, tamanho?:number}} [chanfros] lados com canto chanfrado
     */
    desenhar (g, x, y, w, h, { fundo, fio, fioMeio }, chanfros = { esq: true, dir: true }) {
        const t = MOLDURA.FIO;
        const chanfro = chanfros.tamanho ?? MOLDURA.CHANFRO;
        if (fundo !== null) {
            g.fillStyle(fundo, 1);
            tracar(g, x + t, y + t, w - 2 * t, h - 2 * t, chanfro - t * 0.6, chanfros);
            g.fillPath();
        }

        [fio, fioMeio, fio].forEach((cor, camada) => {
            // O traço é centrado no caminho: recua meio fio além da camada.
            const d = camada * t + t / 2;
            g.lineStyle(t, cor, 1);
            tracar(g, x + d, y + d, w - 2 * d, h - 2 * d, chanfro - d * 0.6, chanfros);
            g.strokePath();
        });
    }
};
